module.exports = __webpack_public_path__ + "img/HHcszorolap2024.f66d963c.jpg";